import styled from 'styled-components';

// Knock-specific date header. The legacy inbox keeps its own all-caps DayTitle; this
// one is sentence case (the section labels are already "Today", "Past 7 days", etc.).
export const DayTitle = styled.p`
  color: ${({ theme }) => theme.palette.grey[700]};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
`;
